import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { FoundingRoundWizard } from '@/components/funding/FoundingRoundWizard';
import { useTenantStore } from '@/hooks/useTenantStore';
import { Card, CardContent } from '@/components/ui/card';

export default function FundingRoundSetup() {
  const { tenantId } = useTenantStore();

  if (!tenantId) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-[60vh]">
          <Card>
            <CardContent className="p-8 text-center text-muted-foreground">
              Select a company to set up a funding round.
            </CardContent>
          </Card>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="py-6">
        <FoundingRoundWizard companyId={tenantId} />
      </div>
    </DashboardLayout>
  );
}
